<template>
  <b-card>
    <div class="audito-connct-title"><span>Auditor Connect</span></div>
    <form-render ref="formRenderAuditorConnect" class="mb-2 fieldQuoter" :key="keyformAuditorConnect" :fields="fields" :form="form" v-if="!loading.allCountries">
      <template #msg="scope">
        <ul class="modal-msj mt-3 mb-0 pl-1" v-if="scope.field.name === 'msg'">
          <li>{{ scope.field.msg }}</li>
        </ul>
      </template>
    </form-render>

    <b-tabs align="left" class="tab-primary" v-model="tabIndex" :key="keyAuditorConnct" v-if="!loading.allCountries">
      <b-tab title="Consulta">
        <billing :goToTab="goToTab"></billing>
      </b-tab>
      <b-tab :title="'Tarifas'">
        <tariffs :company="form.companyId" :country="this.form.countryOfCompany"></tariffs>
      </b-tab>
    </b-tabs>

    <div class="d-flex" v-if="loading.allCountries">
      <b-skeleton height="40px" width="20%" class="m-2 spacing-label-field" />
      <b-skeleton height="40px" width="20%" class="m-2 spacing-label-field" />
      <b-skeleton height="40px" width="20%" class="m-2 spacing-label-field" />
    </div>
  </b-card>
</template>
<script>
import billing from './billing'
import tariffs from './tariffs'
import { mapGetters } from 'vuex'
import BaseServices from '@/store/services/index'

export default {
  components: { billing, tariffs },
  name: 'AuditorConnect',
  data () {
    return {
      baseService: new BaseServices(this),
      tabIndex: 0,
      keyAuditorConnct: 0,
      isTariffs: false,
      adminData: '',
      companyData: null,
      selectedCountry: null,
      keyformAuditorConnect: 1,
      fields: [],
      form: {},
      loading: {
        allCountries: false,
        mySession: true
      }
    }
  },
  computed: {
    ...mapGetters({
      companies: 'getCompaniesDeliveryConnect',
      allCountries: 'getCountriesCoverage',
      mySession: 'getSession',
      generalLoading: 'getLoading'
    })
  },
  watch: {
    mySession () {
      if (this.loading.mySession) {
        this.setInitialData()
      }
    },
    allCountries: {
      handler() {
        this.optionsCountries = this.allCountries.rows
        this.setInitialData()
      },
      deep: true
    },
    generalLoading: {
      handler() {
        this.loading.allCountries = !!this.generalLoading.getCountriesCoverage
      },
      deep: true
    }
  },
  mounted() {
    if (this.m_isAdmin()) {
      this.$store.dispatch('fetchService', { name: 'getCountriesCoverage' })
    } else if (this.loading.mySession && this.$session.get('cas_user')) {
      if (this.$session.get('cas_user')?.global_scope?.organization_id?.[0]) this.changeCompanyId('companyId', {id: this.$session.get('cas_user').global_scope.organization_id[0]})
    }
  },
  methods: {
    setInitialData() {
      this.fields = [
        { name: 'labelCountryCompany', label: this.$t('Company'), useSlot: true, containerClass: 'col-sm-12 label-countries', validation: 'required' },
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: false, name: 'countryOfCompany', disabled: false, containerClass: 'formQuoter_country col-1', change: this.changeCountryOfCompany, addFlags: true, sort: true, placeholder: 'País', clearable: false, onlyFlag: true, options: this.optionsCountries },
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: false, name: 'companyId', id: 'companyId', containerClass: 'formQuoter_origin col-3', change: this.changeCompanyId, dependency: 'countryOfCompany', clearable: true, searchOnType: { fx: this.setSeller, nChars: 3, debounce: 600, persistSearch: true }, sort: true}
      ]
    },
    goToTab(index) {
      this.tabIndex = index
    },
    changeCountryOfCompany(name, value) {
      if (this.form.countryOfOrigin?.code !== value?.code) {
        this.form.countryOfOrigin = value
        this.resetFields(this.fields, ['companyId'])
      }
    },
    changeCompanyId(name, value) {
      this.form.companyId = value
      this.loading.mySession = false
      const queryParams = {}
      const params = {
        company_id: value.id
      }
      this.$store.dispatch('fetchService', { name: 'getCompaniesConnect', queryParams, params })
    },
    async setSeller(value) {
      if (!this.form.countryOfCompany?.id) return []
      const params = { country_id: this.form.countryOfCompany.id }
      const queryParams = { search: value, include_shippers: true }
      try {
        const resp = await this.baseService.callService('getSeller', queryParams, params)
        return resp.data.organizations.map(el => ({ ...el, text: el.fullname, valid: true }))
      } catch (err) {
        this.$newError('Error', err.message, 'large')
        return []
      }
    },
    resetFields(array, arrayValToReset) {
      arrayValToReset.forEach(el => {
        this.m_setSkeletonField(array, 'name', el, true)
      })
      setTimeout(() => {
        arrayValToReset.forEach(el => {
          this.m_setSkeletonField(array, 'name', el, false)
        })
      }, 10)
    }
  }
}
</script>
<style lang="scss">
  .admin-input-container {
    padding: 0 1rem;
  }
  .admin-input {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background-color: #f9f9fd;
  }

  .admin-input-container {
    padding: 0 1rem;
  }
  .fieldSelect--img {
    width: 1.5rem;
    margin-right: 0.5rem;
  }


  .custom-select-wrapper {
    position: relative;
  }

  .custom-select {
    border-radius: 10px;
    padding: 0.5rem 1rem;
    background-color: #fff;
    border: 1px solid #dce1e7;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
  }
  .form-label {
    font-weight: 600;
    font-size: 0.875rem;
    margin-bottom: 0.4rem;
    display: block;
  }

  .input-wrapper {
    display: flex;
    gap: 0;
    max-width: 24rem;
  }

  .input-divider {
    width: 1px;
    background-color: #EAECED;
    height: auto;
    align-self: stretch;
    margin: 0;
  }

  .country-flag-select {
    max-width: 5rem;
    min-width: 5rem;
    background: transparent;
    .vs__dropdown-toggle {
      border-right: none !important;
      border-top-right-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
    }
  }

  .company-name-select {
    flex-grow: 1;
    border: none;
    background: transparent;

    .vs__dropdown-toggle {
      border-left: none !important;
      border-top-left-radius: 0px !important;
      border-bottom-left-radius: 0px !important;
    }
  }

  .flag-icon {
    width: 24px;
    height: 16px;
    object-fit: contain;
  }

  .country-name {
    font-size: 0.775rem;
    font-weight: 600;
  }

  .formQuoter_country {
    padding-right: 0;
    div {
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
  }

  .formQuoter_origin {
    padding-left: 0;
    div {
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    }
  }

  .audito-connct-title {
    color: rgba(241, 136, 5, 1);
    font-size: 24px;
    font-weight: 500;
    margin-top: 1rem;
    margin-bottom: 2rem;
    border-bottom: 1px solid rgba(4, 67, 137, 0.1);
    span {
      margin-left: 1rem;
    }
  }
</style>
